module.exports = __webpack_public_path__ + "img/Portafolio Lacandonia_3.12744ce1.png";